import { render, staticRenderFns } from "./Weblogs.vue?vue&type=template&id=20e97ccf&scoped=true&"
import script from "./Weblogs.vue?vue&type=script&lang=js&"
export * from "./Weblogs.vue?vue&type=script&lang=js&"
import style0 from "./Weblogs.vue?vue&type=style&index=0&id=20e97ccf&scoped=true&lang=css&"
import style1 from "./Weblogs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e97ccf",
  null
  
)

export default component.exports